"use strict";

/**
 * @ngdoc function
 * @name diceApp.component:condensedReport
 */
angular.module("diceApp").component("condensedReport", {
  bindings: {
    year: "<?",
    evaluationIds: "<?",
    evaluationType: "<?",
    selectedQuestionTemplateIds: "<?",
    templateId: "<?"
  },
  templateUrl: "es6/report/condensed/condensed.report.html",
  controllerAs: "reportController",
  controller: function (CondensedReport, language, Export, descriptionFilter, slimNumberFilter, stripHtmlFilter, $q, $window) {
    const reportController = this;

    reportController.$onInit = function () {
      reportController.loadReport();
    };

    reportController.loadReport = function () {
      reportController.loading = true;

      getReport(1)
        .then((report) => {
          reportController.report = report;
          setReportColumns();
        })
        .finally(() => {
          reportController.loading = false;
          // eslint-disable-next-line angular/window-service
          if (window.matchMedia) {
            // eslint-disable-next-line angular/window-service
            window.addEventListener("beforeprint", () => reportController.preparePrint());
          }
        });
    };

    function getReport(page) {
      const form = {
        evaluationIds: reportController.evaluationIds,
        templateId: reportController.templateId,
        language: language.get()
      };

      const params = {
        page,
        size: 50,
        sort: "id,asc"
      };

      return CondensedReport.generate(params, form).$promise.then((report) => {
        const evaluations = _.get(report, "evaluations.content", []);
        _.forEach(evaluations, prepare);

        const last = _.get(report, "evaluations.last", true);
        if (last) {
          return _.extend(report, { evaluations });
        }

        return getReport(page + 1, report).then((next) => {
          const additional = _.get(next, "evaluations", []);
          return _.extend(report, {
            evaluations: [...evaluations, ...additional]
          });
        });
      });
    }

    function prepare(evaluation) {
      _.forEach(evaluation.questionAnswers, (question) => {
        question.summary = CondensedReport.formatQuestionAnswers(question);
      });
    }

    function setReportColumns() {
      const defaultColumns = [
        {
          code: "id",
          name: "ID",
          visible: true
        },
        {
          code: "code",
          name: "Code",
          visible: true
        },
        {
          code: "name",
          name: "Name",
          visible: true
        },
        {
          code: "periodName",
          name: "Period",
          visible: true
        },
        {
          code: "amountOfParticipants",
          name: "Participants",
          visible: true
        }
      ];

      const questionColumns = _(reportController.report.questions)
        .sortBy('index')
        .map((question, index) => ({
            code: `questionAnswers[${index}].summary`,
            name: stripHtmlFilter(descriptionFilter(question.question.labels)),
            visible: true
        })).value();

      reportController.reportColumns = [
        ...defaultColumns,
        ...questionColumns
      ];
    }

    reportController.getReportRows = function () {
      const rows = _.sortBy(reportController.report.evaluations, ['code', 'periodName']);
      return $q.resolve(rows);
    };

    reportController.exportAsPdf = function () {
      Export.generatePdf($window.location.href, language.get());
    };

    reportController.preparePrint = function () {
      const cloneTable = (table) => {
        const currentClasses = table.getAttribute("class");
        const trs = Array.from(table.querySelectorAll("tbody tr"));
        // eslint-disable-next-line angular/document-service
        let printableTable = document.createElement("table");

        printableTable.setAttribute("class", currentClasses);
        printableTable.classList.replace("no-print", "print-only");

        let allPrintableTrs = "";
        trs.forEach((tr) => {
          const trClass = tr.getAttribute("class");
          allPrintableTrs += `<tr class="${trClass}"></tr>`;
        });

        const theadClass =
          table.querySelector("thead")?.getAttribute("class") || "";
        const theadTrClass =
          table.querySelector("thead tr")?.getAttribute("class") || "";
        const tbodyClass =
          table.querySelector("tbody")?.getAttribute("class") || "";
        printableTable.innerHTML = `<thead class="${theadClass}"><tr class="${theadTrClass}"></tr></thead><tbody class="${tbodyClass}">${allPrintableTrs}</tbody>`;

        return printableTable;
      };

      // set width to "A4" dimension so we calculate on the correct width
      // eslint-disable-next-line angular/document-service
      document.body.style.width = "210mm";

      // eslint-disable-next-line angular/document-service
      const table = document.querySelector(".printable-table");
      if (!table) {
        return;
      }

      const parent = table.parentElement;
      const { width: parentWidth } = parent.getBoundingClientRect();
      const { width: tableWidth } = table.getBoundingClientRect();

      if (parentWidth >= tableWidth) {
        // print fits.
        table.classList.remove("no-print");
        // eslint-disable-next-line angular/document-service
        document.body.style.width = "auto";
        return;
      }

      if (parentWidth < tableWidth) {
        // we will split the table evenly by amount of columns;
        const ths = Array.from(table.querySelectorAll("thead th"));

        const totalPages = Math.ceil(tableWidth / parentWidth);
        const splitOnColumn = Math.ceil(ths.length / totalPages);
        let currPage = 1;

        const trs = Array.from(table.querySelectorAll("tbody tr"));
        let printableTable = cloneTable(table);
        table.insertAdjacentElement("beforebegin", printableTable);

        ths.forEach((item, thIndex) => {
          if (splitOnColumn === (thIndex + 1) / currPage) {
            currPage += 1;
            // Make a new table for collapsing
            printableTable = cloneTable(table);
            table.insertAdjacentElement("beforebegin", printableTable);
          }

          const printTh = printableTable.querySelector("thead tr");
          const thClass = item.getAttribute("class");
          printTh.insertAdjacentHTML(
            "beforeend",
            `<th class="${thClass}">${item.innerHTML}</th>`
          );

          trs.forEach((tr, trIndex) => {
            const tds = Array.from(tr.querySelectorAll("td"));
            const currTd = tds[thIndex];
            const currPrintTr = Array.from(
              printableTable.querySelectorAll(`tbody tr`)
            )[trIndex];

            const tdClass = currTd.getAttribute("class");
            currPrintTr.insertAdjacentHTML(
              "beforeend",
              `<td class="${tdClass}">${currTd.innerHTML}</td>`
            );
          });
        });

        // eslint-disable-next-line angular/document-service
        document.body.style.width = "auto";
      }
    };
  }
});
